import { Button, Modal } from "antd";
import React from "react";

interface ConfirmationModalProps {
    open: boolean;
    saving: boolean;
    onCancel: () => void;
    onSave: () => void;
    confirmDisabled?: boolean;
    title?: string;
    message?: string;
    confirmButtonText?: string;
}

export const ConfirmationModal = ({
    open,
    saving,
    onCancel,
    onSave,
    confirmDisabled = false,
    title = "Unsaved changes",
    message = "You have unsaved changes. Save your changes before continuing.",
    confirmButtonText = "Save",
}: ConfirmationModalProps) => (
    <Modal
        open={open}
        title={title}
        onCancel={onCancel}
        centered
        zIndex={1200}
        closable={!saving}
        mask={{ closable: !saving }}
        keyboard={!saving}
        width={350}
        footer={[
            <Button key="cancel" onClick={onCancel} disabled={saving}>
                Cancel
            </Button>,
            <Button
                key="save"
                color="primary"
                variant="solid"
                onClick={onSave}
                loading={saving}
                disabled={confirmDisabled}
            >
                {confirmButtonText}
            </Button>,
        ]}
    >
        {message}
    </Modal>
);
